import React from "react";
import { useDispatch } from "react-redux";
import { increaseCartQty } from "../../Features/Cart/cartActions";
// import { increaseQty, removeItemFromCart } from "../features/cart/cartSlice";

const QuantityControl = ({ currentItem = {} }) => {
  const dispatch = useDispatch();

  // const { user: authUser = {} } = useSelector((state) => state.auth);

  let quantity = currentItem.quantity ?? 0;

  const incrementQuantity = (value) => {
    if (value === "addition") {
      dispatch(
        increaseCartQty({
          ...currentItem,
          quantity: quantity + 1,
          type: value,
        }),
      );
    } else {
      dispatch(
        increaseCartQty({
          ...currentItem,
          quantity: quantity - 1,
          type: value,
        }),
      );
    }
    // ;
  };

  // const decrementQuantity = () => {
  //   if (authUser?.accessToken) {
  //     dispatch(removeFromCart(currentItem?.productId));
  //   } else {
  //     dispatch(removeFromCart(currentItem.id));
  //   }
  //   // dispatch(removeFromCart(currentItem.id));
  // };

  return (
    <div className="border border-gray-100 rounded-pill py-5 px-10 flex-align justify-content-between">
      <button
        // onClick={decrementQuantity}
        onClick={() => incrementQuantity("deduct")}
        type="button"
        className="quantity__minus p-4 text-gray-700 hover-text-main-600 flex-center"
      >
        {quantity === 1 ? (
          <i className="ph ph-trash text-danger"></i>
        ) : (
          <i className="ph ph-minus" />
        )}
      </button>
      <input
        type="number"
        className="quantity__input border-0 text-center w-32"
        value={quantity}
        readOnly
      />
      <button
        onClick={() => incrementQuantity("addition")}
        type="button"
        className="quantity__plus p-4 text-gray-700 hover-text-main-600 flex-center"
      >
        <i className="ph ph-plus" />
      </button>
    </div>
  );
};

export default QuantityControl;
